import { downloadUrl, type DownloadResult } from '@/utils/download';
import type { DispatchPayload } from './tim-bridge';

type DownloadPayload = Extract<DispatchPayload, { type: 'DOWNLOAD' }>;

export function handleDownload(payload: DownloadPayload): DownloadResult {
  return downloadUrl({
    requestId: payload.requestId,
    url: payload.url,
    fileName: payload.fileName,
    mimeType: payload.mimeType,
    mediaKind: payload.mediaKind,
    saveToPhotos: payload.saveToPhotos
  });
}
